import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDrop } from 'react-dnd';
import { Paper } from '@mui/material';
import Close from '@mui/icons-material/Close';
import page from 'assets/img/page.png';
import { IconButton } from '@totalsoft/rocket-ui';
import { useHover } from '../bulkUpload/useHover';
import { Visibility } from '@mui/icons-material';

const style = {
  marginRight: '1rem',
  textAlign: 'center',
  height: 167,
  width: 120,
  fontSize: 'small'
};

const landScapeStyle = {
  marginRight: '2rem',
  textAlign: 'center',
  height: 167,
  width: 120,
  fontSize: 'small',
  marginLeft: '2em'
};

function selectBackgroundColor(isActive, canDrop) {
  if (isActive && !canDrop) {
    return 'red';
  }
  if (isActive) {
    return 'yellow';
  } else if (canDrop) {
    return 'rgba(34,139,34,.2)';
  } else {
    return 'transparent';
  }
}
export const Dustbin = ({ item, onDrop, onPreview, index, onRemove, accept, scrollRef, onFileReorder }) => {
  const { isHovered, handleMouseEnter, handleMouseLeave } = useHover();
  const [{ isOver, canDrop }, drop] = useDrop({
    accept: accept, //[ItemTypes.FILE, ItemTypes.PAGE],
    drop: onDrop,
    collect: monitor => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop()
    })
  });
  const handleOnRemove = useCallback(
    item => () => {
      onRemove(item);
    },
    [onRemove]
  );

  const handleOnPreview = useCallback(() => onPreview(item, true), [item, onPreview]);

  const isActive = canDrop && isOver;
  const boxShadow = `inset 0 0 0 20px ${selectBackgroundColor(isActive, canDrop)}`;
  return (
    <div style={item?.rotationAngle !== 0 && item?.rotationAngle !== 180 ? { ...landScapeStyle } : { ...style }}>
      {item?.name ? (
        <div style={{ position: 'relative' }}>
          {item?.page && <span style={{ position: 'absolute', top: 0, left: 50 }}>P{item?.page}</span>}
          <IconButton onClick={handleOnRemove(item)} color={'transparent'} size='tiny' sx={{ left: 50 }}>
            <Close sx={theme => ({ width: theme.spacing(2.5), height: theme.spacing(2.5) })} />
          </IconButton>
          <div onClick={handleOnPreview} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <div
              draggable
              onDragStart={e => {
                e.dataTransfer.setData('text/plain', index);
              }}
              onDrop={e => {
                onFileReorder(Number(e.dataTransfer.getData('text/plain')), index);
              }}
              onDragOver={e => {
                e.preventDefault();
              }}
            >
              <Paper
                title={item?.fileName}
                elevation={3}
                style={{
                  marginTop: 5,
                  height: 167,
                  width: 120,
                  transform: `rotate(${item.rotationAngle ?? 0}deg)`,
                  filter: isHovered ? 'blur(3px)' : 'none',
                  opacity: isHovered ? 0.8 : 1,
                  cursor: isHovered ? 'pointer' : 'default'
                }}
              >
                {item?.name}
              </Paper>
            </div>

            {isHovered && (
              <div
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  zIndex: 1,
                  cursor: 'pointer'
                }}
              >
                <Visibility />
              </div>
            )}
          </div>
          <div title={item?.fileName} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {item?.fileName}
          </div>
        </div>
      ) : (
        <div
          ref={drop}
          style={{
            boxShadow,
            backgroundImage: `url(${page})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            width: 120,
            height: 167,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: 35
          }}
        >
          <span style={{ fontSize: '35px', color: '#d7e2ea', fontFamily: 'fantasy', fontWeight: 900, letterSpacing: '6px' }}>
            {index < 9 ? `0${index + 1}` : index + 1}
          </span>
        </div>
      )}
      <div ref={scrollRef}></div>
    </div>
  );
};

Dustbin.propTypes = {
  allowedDropEffect: PropTypes.string,
  item: PropTypes.object,
  onDrop: PropTypes.func,
  onPreview: PropTypes.func.isRequired,
  index: PropTypes.number,
  onRemove: PropTypes.func,
  accept: PropTypes.array,
  scrollRef: PropTypes.object,
  onFileReorder: PropTypes.func.isRequired
};
